import { render, staticRenderFns } from "./Tires.vue?vue&type=template&id=13b0c115"
import script from "./Tires.vue?vue&type=script&lang=js"
export * from "./Tires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports